package com.wintermar.inspection.feature.util.template_status

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.component.TextBodyTiny
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.util.modifier.badge
import com.wintermar.inspection.graphql.type.InspectionTemplateStatus

@Composable
fun TemplateStatusView(
    status: InspectionTemplateStatus,
    dimension: AppDimension = LocalAppTheme.current.dimension
) {
    val variant = status.toVariant()

    Row(
        modifier = Modifier.badge(
            backgroundColor = variant.backgroundColor,
            borderColor = variant.borderColor
        ),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(
            dimension.spacing.space2
        )
    ) {
        TextBodyTiny(
            text = variant.label,
            color = { variant.labelColor },
            bold = true
        )
    }
}
